import FollowUpFormTabV2 from "./followupFormTabV2";

export default FollowUpFormTabV2;
